<template>
  <div class="deposit">
      <div class="deposit_1">
        <!-- <div :class="index_active==1?'active':'' ">
          <router-link to="/blockchain_w/transfer_p">{{$t('main.text15')}}</router-link>
        </div> -->

        <!-- <div :class="index_active==2?'active':'' ">
          <router-link to="/blockchain_w/fiat_t_h">{{$t('main.text336')}}</router-link>
        </div> -->
        
        <!-- <div :class="index_active==3?'active':'' ">
          <router-link to="/blockchain_w/digital_t_h">{{$t('main.text337')}}</router-link>
        </div> -->

        <div :class="index_active==4?'active':'' ">
          <router-link to="/blockchain_w/transfer_p_fiat">{{$t('main.text749')}}</router-link>
        </div>
        <div :class="index_active==5?'active':'' ">
          <router-link to="/blockchain_w/transfer_p_jmhb">{{$t('main.text750')}}</router-link>
        </div>

      </div>
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index_active:1,
    }
  },
  methods: {
    set_active(){
      if(this.$route.path=='/blockchain_w/transfer_p'){
        this.index_active = 1;
      }else if(this.$route.path=='/blockchain_w/fiat_t_h'){
        this.index_active = 2;
      }else if(this.$route.path=='/blockchain_w/digital_t_h'){
        this.index_active = 3;
      }else if(this.$route.path=='/blockchain_w/transfer_p_fiat'){
        this.index_active = 4;
      }else if(this.$route.path=='/blockchain_w/transfer_p_jmhb'){
        this.index_active = 5;
      }

    },
  },
  mounted() {
    this.set_active();
  },
  watch:{
    $route(){
      this.set_active();
    }
  }
}
</script>

<style scoped>

.deposit_1{
  border-bottom: 1px solid #314B69;
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
}
.deposit_1 a{
  color: #fff;
}
.deposit_1>div{
  margin-right: 40px;
  line-height: initial;
}
.active{
  font-style: normal;
  font-weight: 700;
  color: #00C18E;
  border-bottom: 3px solid #00C18E;
  padding-bottom: 4px;
}
.active a{
  color: #00C18E;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .deposit_1{
    font-size: 12px;
  }
  
}
</style>